module.exports = __webpack_public_path__ + "img/girl-obl.a114c8cb.png";